
import { PopupRoot } from './PopupRoot'

export const Popup = {
  Root: PopupRoot,
}